import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Avatar, AvatarGroup } from '@mui/material';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { UserContext } from '../../context/UserContext';
import './YourCommunities.css';
import vector from './vector.svg';

const YourCommunities = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [yourCommunities, setYourCommunities] = useState([]);

  useEffect(() => {
    if (!user) return;

    const fetchUserGroups = async () => {
      const groupsQuery = query(collection(db, "groups"), where("members", "array-contains", user.uid));
      const querySnapshot = await getDocs(groupsQuery);
      
      const userGroups = querySnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          memberAvatars: data.memberAvatars ? data.memberAvatars.slice(0, 3) : [], // Ensure max 3 avatars
        };
      });
      
      setYourCommunities(userGroups);
    };

    fetchUserGroups();
  }, [user]);

  const goToGroupChat = (groupId) => {
    navigate(`/messages?group=${groupId}`);
  };

  return (
    <div className="your-communities" style={{ backgroundColor: '#FFFFFF' }}>
      <h2 className="section-title">Your communities</h2>
      <div className="communities-grid">
        {yourCommunities.map(community => (
          <div key={community.id} className="community-card">
            <div className="community-image-container">
              <img src={community.image} alt={community.title} className="community-image" />
            </div>
            <div className="community-content">
              <h3 className="community-title">{community.title}</h3>
              <div className="community-members">
                <AvatarGroup max={3} sx={{ '& .MuiAvatar-root': { width: 24, height: 24, fontSize: '0.8rem' } }}>
                  {community.memberAvatars.map((avatar, index) => (
                    <Avatar key={index} src={avatar} />
                  ))}
                </AvatarGroup>
                <span className="member-count">{community.members.length}+ people</span>
              </div>
              <p className="community-description">{community.description}</p>
              <Button variant="contained" onClick={() => goToGroupChat(community.conversationId)} startIcon={<img src={vector} alt="view" style={{ width: '20px', height: '20px' }} />} className="view-group-btn">
                VIEW GROUP
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default YourCommunities;
